<template>
  <div class="resource_statistic_wrap account_set_wrap" v-loading="loading">
    <div class="resource_statistic_header account_set_header">
      <h2>资源统计</h2>
      <div class="header_group">
        <span class="item">
          <span>组织选择:</span>
          <el-select
            filterable
            size="mini"
            v-model="organize"
            placeholder="全部组织"
            :popper-append-to-body="false"
            clearable
            @change="
              (val) => {
                handleSelectChange(val, 'organize', organizeList);
              }
            "
          >
            <el-option
              v-for="(dynmaici, dynmaicindex) in organizeList"
              :key="dynmaicindex + 'a'"
              :label="dynmaici.structName"
              :value="dynmaici.structId"
              :title="dynmaici.structName"
            ></el-option>
          </el-select>
        </span>
        <span class="item" v-if="false">
          <span>老师选择:</span>
          <el-select
            filterable
            size="mini"
            v-model="teacher"
            placeholder="全部老师"
            @change="
              (val) => {
                handleSelectChange(val, 'teacher', teacherList);
              }
            "
          >
            <el-option
              v-for="(dynmaici, dynmaicindex) in teacherList"
              :key="dynmaicindex + 'a'"
              :label="dynmaici.name"
              :value="dynmaici.code"
              :title="dynmaici.name"
            ></el-option>
          </el-select>
        </span>
        <span class="item">
          <span>课程选择:</span>
          <el-select
            filterable
            size="mini"
            v-model="course"
            placeholder="全部课程"
            :popper-append-to-body="false"
            clearable
            @change="
              (val) => {
                handleSelectChange(val, 'course', courseList);
              }
            "
          >
            <el-option
              v-for="(dynmaici, dynmaicindex) in courseList"
              :key="dynmaicindex + 'a'"
              :label="dynmaici.courseName"
              :value="dynmaici.id"
              :title="dynmaici.courseName"
            >
              <template v-if="dynmaici.authStatus == 2">
                <span>
                  <span style="color: #ed9347">【授权过期】</span>
                  {{ dynmaici.courseName }}
                </span>
              </template>
            </el-option>
          </el-select>
        </span>
        <span class="item" v-if="false">
          <span>数据范围:</span>
          <el-select
            filterable
            size="mini"
            v-model="resource"
            placeholder="全部数据"
            @change="
              (val) => {
                handleSelectChange(val, 'resource', resourceList);
              }
            "
          >
            <el-option
              v-for="(dynmaici, dynmaicindex) in resourceList"
              :key="dynmaicindex + 'a'"
              :label="dynmaici.name"
              :value="dynmaici.code"
              :title="dynmaici.name"
            ></el-option>
          </el-select>
        </span>
        <span class="item" v-if="false">
          <span>数据时间:</span>
          <el-date-picker
            v-model="resourceTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
          ></el-date-picker>
          <!-- :picker-options="pickerOptions" -->
        </span>
      </div>
    </div>
    <!-- 产品统计 -->
    <div class="product_section">
      <div class="product_section_header">
        <span class="header_left">
          <span class="product_title">产品统计</span>
          <!-- <el-button type="text">查看详情</el-button> -->
        </span>
        <span class="header_right"
          >数据更新时间：{{ updateTime | formatTime }}</span
        >
      </div>
      <ul class="product_section_list">
        <li
          class="product_tiem"
          v-for="(item, index) in productList"
          :key="index"
        >
          <div class="product_left">
            <span
              class="iconMin"
              :style="{ backgroundImage: `url(${item.icon})` }"
            ></span>
          </div>
          <div class="product_right">
            <span class="product_count">{{ item.count }}{{ item.unit }}</span>
            <span>{{ item.name }}</span>
          </div>
        </li>
      </ul>
    </div>

    <!-- 资源类型 -->
    <div class="type_section">
      <ul class="type_section_list">
        <li class="type_tiem" v-for="(item, index) in typeList" :key="index">
          <div class="type_left">
            <span class="type_count">
              {{ item.count }}
              <span class="unit">{{ item.unit }}</span>
            </span>
            <span>{{ item.name }}</span>
          </div>
          <div class="type_right">
            <span
              class="iconMin"
              :style="{ backgroundImage: `url(${item.icon})` }"
            ></span>
          </div>
        </li>
      </ul>
      <div
        class="echarts_item"
        id="source_type"
        style="width: 482px; height: 316px"
      ></div>
      <div
        class="echarts_item"
        id="source_percent"
        style="width: 482px; height: 316px"
      ></div>
    </div>

    <!-- bottom -->
    <div class="type_section">
      <div
        class="echarts_item item1"
        id="bottom_type1"
        style="width: 440px; height: 326px"
      ></div>
      <div
        class="echarts_item item1"
        id="bottom_type2"
        style="width: 440px; height: 326px"
      ></div>
      <div
        class="echarts_item item2"
        id="bottom_type3"
        style="width: 806px; height: 326px"
      ></div>
    </div>
  </div>
</template>
<script>
import * as api from "../../../../../api/resourceStatistic";
export default {
  components: {},
  data() {
    return {
      loading: false,
      // ------------------------------------
      deptId: sessionStorage.getItem("deptId"),
      course: "", // 课程
      courseList: [
        // {
        //   id: 123,
        //   courseName: "智能财税机器人",
        // },
        // {
        //   id: 124,
        //   courseName: "智能财税机器人666",
        // },
      ],
      organize: "", // 组织
      organizeList: [],
      teacher: "", // 老师
      teacherList: [
        { name: 111, code: 1 },
        { name: 222, code: 2 },
      ],
      resource: "", // 数据范围
      resourceList: [
        { name: 333, code: 1 },
        { name: 444, code: 2 },
      ],
      resourceTime: "", // 数据时间
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      updateTime: new Date(new Date().toLocaleDateString()), // 更新时间
      productList: [
        // 产品统计
        {
          name: "开通产品",
          count: 0,
          unit: "个",
          icon: "/static/images/statistic/kfcp.png",
        },
        {
          name: "课程资源",
          count: 0,
          unit: "个",
          icon: "/static/images/statistic/kczy.png",
        },
        {
          name: "试卷资源",
          count: 0,
          unit: "套",
          icon: "/static/images/statistic/sjzy.png",
        },
        // {
        //   name: "题库数量",
        //   count: 0,
        //   unit: "个",
        //   icon: "/static/images/statistic/tksl.png", // tod
        // },
        // 暂时不显
        // {
        //   name: "产品即将到期",
        //   count: 5,
        //   unit: "个",
        //   icon: "/static/images/statistic/cpdq.png",
        // },
        // {
        //   name: "已过期产品",
        //   count: 5,
        //   unit: "个",
        //   icon: "/static/images/statistic/cpgq.png",
        // },
      ],
      typeList: [
        // 资源类型
        {
          name: "素材总数",
          count: 0,
          icon: "/static/images/statistic/sc.png",
          unit: "个",
        },
        {
          name: "素材总量",
          count: 0,
          icon: "/static/images/statistic/sc2.png",
          unit: "G", // 默认
        },
        {
          name: "视频总时长",
          count: 0,
          icon: "/static/images/statistic/spsc.png",
          unit: "分钟",
        },
        {
          name: "题库总量",
          count: 0,
          icon: "/static/images/statistic/tkzl.png", // tod
          unit: "个",
        },
      ],
      color: [
        new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
          {
            offset: 0,
            color: "#31A8FF",
          },
          {
            offset: 1,
            color: "#5FD3FF",
          },
        ]),
        new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
          {
            offset: 0,
            color: "#FFAA00",
          },
          {
            offset: 1,
            color: "#FFD54D",
          },
        ]),
        new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
          {
            offset: 0,
            color: "#2FC25B",
          },
          {
            offset: 1,
            color: "#43CF7C",
          },
        ]),
        new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
          {
            offset: 0,
            color: "#FFB67A",
          },
          {
            offset: 1,
            color: "#FF793D",
          },
        ]),

        new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
          {
            offset: 0,
            color: "#2F76D8",
          },
          {
            offset: 1,
            color: "#5CAEEE",
          },
        ]),
        new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
          {
            offset: 0,
            color: "#FC8260",
          },
          {
            offset: 1,
            color: "#FFB5B5",
          },
        ]),
        new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
          {
            offset: 0,
            color: "#9999FF",
          },
          {
            offset: 1,
            color: "#C9C9FF",
          },
        ]),
        new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
          {
            offset: 0,
            color: "#78A3E3",
          },
          {
            offset: 1,
            color: "#CDE0F8",
          },
        ]),
      ],
      myChart1: "",
      myChart2: "",
      myChart3: "",
      myChart4: "",
      myChart5: "",
      option1: {},
      option2: {},
      option3: {},
      option4: {},
      option5: {},
      dataStyle: {
        normal: {
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          shadowBlur: 0,
          shadowColor: "#203665",
        },
      },
    };
  },
  created() {
    this.queryStructFirstLevel(); // 获取组织
    // this.getFamousQuotes(); // 数据时间
    this.queryOpenedProd(); // 已开通产品数
    this.queryCourseByStructId(); // 课程范围-课程资源
    // this.queryWillExpiredProd(); // 即将到期
    // this.queryExpiredPro(); // 已到期

    this.option1 = {
      title: {
        show: true,
        text: "素材媒体类型",
        top: 20,
        left: 20,
        textStyle: {
          fontSize: 18,
          fontWeight: 400,
          color: "rgba(0,0,0,1)",
        },
      },
      color: this.color,
      tooltip: {
        // trigger: "item",
        backgroundColor: "#fff",
        extraCssText: "box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.15);",
        padding: [12, 16, 12, 16],
        textStyle: {
          width: 142,
          height: 60,
          fontSize: 12,
          color: "rgba(0,0,0,0.45)",
        },
        // 悬浮的位置可以调整，总距离左边10px
        position: (point) => {
          return ["10", point[1]];
        },
        formatter: (param) => {
          let { marker, name, value, data, color, percent } = param;
          var dotHtml = `<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:${color["colorStops"][0]["color"]}"></span>`;
          var emptyHtml = `<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background:none}"></span>`;
          let result = `<div>${dotHtml}${name}：</div>`;
          // result += `<div style="font-weight: 600;">${emptyHtml}${value}</div>`;
          result += `<div style="font-weight: 600;">${emptyHtml}${percent}%</div>`;

          return result;
        },
      },
      legend: {
        right: 10,
        bottom: "20%",
        orient: "vertical",
        itemWidth: 8,
        itemHeight: 8,
        borderRadius: 5,
        icon: "circle",
        // data: data,
      },
      series: [
        {
          name: "", // 媒体类型
          type: "pie",
          radius: ["30%", "50%"],
          center: ["50%", "50%"], // 图形位置
          avoidLabelOverlap: false, // 防止标签重叠策略
          label: {
            show: false, // 图形上的文本标签
            // position: "center"
          },
          emphasis: {
            // 高亮状态的扇区和标签样式
            label: {
              show: false,
              fontSize: "40",
              fontWeight: "bold",
            },
          },
          labelLine: {
            // 标签的视觉引导线配置
            show: false,
          },
          data: [],
        },
      ],
      graphic: {
        type: "text",
        left: "center",
        top: "middle",
        silent: true,
        invisible: true,
        style: {
          fill: "#767484",
          fontWeight: "400",
          text: "暂无数据",
          fontSize: 16,
        },
      },
    };

    this.option2 = {
      title: {
        show: true,
        text: "活跃资源占比",
        top: 20,
        left: 20,
        textStyle: {
          fontSize: 18,
          fontWeight: 400,
        },
      },
      series: [
        {
          name: "占比",
          type: "liquidFill",
          color: ["#1890FF", "#91D5FF"],
          // waveAnimation: false, // 是否流动
          data: [
            0.34, // tod
            // {
            //   value: 0.34,
            //   direction: "left",
            // },
          ],
          center: ["50%", "50%"],
          radius: "50%",
          outline: {
            itemStyle: {
              borderWidth: 2.5,
              borderColor: "rgba(24, 144, 255, 1)",
            },
          },
          backgroundStyle: {
            color: "#fff",
          },
          itemStyle: {
            opacity: 0.95,
            shadowColor: "rgba(0, 0, 0, 0)",
          },
          label: {
            formatter: function (p) {
              // return `{b|${p.value * 100}}%\n{a|${p.seriesName}}`;
              // return `{b|${(p.value * 100).toFixed()}}%`;
              return `{b|${Math.round(p.value * 10000) / 100}}%`;
            },
            rich: {
              a: {
                fontSize: 14,
              },
            },
            position: ["50%", "35%"],
            fontSize: 32,
            fontWeight: 400,
            fontFamily: "SourceHanSansCN",
            color: "rgba(0, 0, 0, 0.85)",
          },
        },
      ],
    };

    this.option3 = {
      title: {
        show: true,
        text: "题库按主客观题分类",
        top: 20,
        left: 20,
        textStyle: {
          fontSize: 18,
          fontWeight: 400,
        },
      },
      backgroundColor: "#fff",
      color: [
        new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
          {
            offset: 0,
            color: "#FCAFA9",
          },
          {
            offset: 1,
            color: "#FFF786",
          },
        ]),
        new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
          {
            offset: 0,
            color: "#30A9FF",
          },
          {
            offset: 1,
            color: "#5FD3FF",
          },
        ]),
      ],
      tooltip: {
        backgroundColor: "#fff",
        extraCssText: "box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.15);",
        padding: [12, 16, 12, 16],
        textStyle: {
          color: "rgba(0,0,0,0.65)",
        },
        // 悬浮的位置可以调整，总距离左边10px
        // position: point => {
        //     return ["10", point[1]];
        // },
        formatter: (param) => {
          // let { marker, name, value, data } = param;
          // let result = `<div>${marker}${name}</div>`;
          // result += `<div>${value}</div>`;
          // return result;
          let { marker, name, value, data, color } = param;
          // if (typeof color == "string") return;
          // let tempColor =
          //   typeof color == "string" ? color : color["colorStops"][0]["color"];
          var dotHtml = `<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:${data.displayColor}"></span>`;
          var emptyHtml = `<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background:none}"></span>`;
          let result = `<div>${dotHtml}${name}：</div>`;
          // result += `<div style="font-weight: 600;">${emptyHtml}${data.displayValue}</div>`;
          result += `<div style="font-weight: 600;">${emptyHtml}${
            Math.round(data.displayPercent * 10000) / 100
          }%</div>`;
          return result;
        },
      },
      legend: {
        right: 10,
        bottom: 50,
        // orient: "vertical",
        orient: "horizontal",
        itemWidth: 8,
        itemHeight: 8,
        icon: "circle",
      },
      series: [],
    };

    this.option4 = {
      title: {
        show: true,
        text: "题库按题型分类",
        top: 20,
        left: 20,
        textStyle: {
          fontSize: 18,
          fontWeight: 400,
          color: "rgba(0,0,0,1)",
        },
      },
      color: this.color,
      tooltip: {
        // trigger: "item",
        backgroundColor: "#fff",
        extraCssText: "box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.15);",
        padding: [12, 16, 12, 16],
        textStyle: {
          width: 142,
          height: 60,
          fontSize: 12,
          color: "rgba(0,0,0,0.45)",
        },
        // 悬浮的位置可以调整，总距离左边10px
        position: (point) => {
          return ["10", point[1]];
        },
        formatter: (param) => {
          let { marker, name, value, data, color, percent } = param;
          var dotHtml = `<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:${color["colorStops"][0]["color"]}"></span>`;
          var emptyHtml = `<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background:none}"></span>`;
          let result = `<div>${dotHtml}${name}：</div>`;
          // result += `<div style="font-weight: 600;">${emptyHtml}${value}</div>`;
          result += `<div style="font-weight: 600;">${emptyHtml}${percent}%</div>`;
          return result;
        },
      },
      legend: {
        right: 10,
        bottom: "20%",
        orient: "vertical",
        itemWidth: 8,
        itemHeight: 8,
        borderRadius: 5,
        icon: "circle",
        // data: data,
      },
      series: [
        {
          name: "", // 题库类型
          type: "pie",
          radius: ["30%", "50%"],
          center: ["50%", "50%"], // 图形位置
          avoidLabelOverlap: false, // 防止标签重叠策略
          label: {
            show: false, // 图形上的文本标签
            // position: "center"
          },
          emphasis: {
            // 高亮状态的扇区和标签样式
            label: {
              show: false,
              fontSize: "40",
              fontWeight: "bold",
            },
          },
          labelLine: {
            // 标签的视觉引导线配置
            show: false,
          },
          data: [],
        },
      ],
      graphic: {
        type: "text",
        left: "center",
        top: "middle",
        silent: true,
        invisible: true,
        style: {
          fill: "#767484",
          fontWeight: "400",
          text: "暂无数据",
          fontSize: 16,
        },
      },
    };

    this.option5 = {
      title: {
        show: true,
        text: "题库按难度分类",
        top: 20,
        left: 20,
        textStyle: {
          fontSize: 18,
          fontWeight: 400,
        },
      },
      backgroundColor: "#fff",
      tooltip: {
        show: false,
        backgroundColor: "#fff",
        extraCssText: "box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.15);",
        padding: [12, 16, 12, 16],
        textStyle: {
          color: "rgba(0,0,0,0.65)",
        },
        // 悬浮的位置可以调整，总距离左边10px
        // position: point => {
        //     return ["10", point[1]];
        // },
        formatter: (param) => {
          // let { marker, name, value, data } = param;
          // let result = `<div>${marker}${name}</div>`;
          // result += `<div>${value}</div>`;
          // return result;
          let { marker, name, value, data, color } = param;
          if (typeof color == "string") return;
          let tempColor =
            typeof color == "string" ? color : color["colorStops"][0]["color"];
          var dotHtml = `<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:${tempColor}"></span>`;
          var emptyHtml = `<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background:none}"></span>`;
          let result = `<div>${dotHtml}${name}：</div>`;
          result += `<div style="font-weight: 600;">${emptyHtml}${value}</div>`;
          return result;
        },
      },
      series: [
        {
          name: "第一个圆环",
          type: "pie",
          clockWise: true,
          radius: ["40%", "32%"],
          itemStyle: this.dataStyle,
          hoverAnimation: false,
          center: ["15%", "50%"],
          data: [
            {
              name: "困难",
              value: 0, // tod
              percentage: 0, // 百分比
              label: {
                normal: {
                  rich: {
                    a: {
                      color: "rgba(0, 0, 0, 0.85)",
                      align: "center",
                      fontSize: 28,
                    },
                    b: {
                      color: "rgba(0, 0, 0, 0.45)",
                      align: "center",
                      fontSize: 14,
                    },
                  },
                  formatter: function (params) {
                    // console.log(params, "params1");
                    // return "{b|困难}\n\n" + "{a|" + params.value + "%}";
                    return (
                      "{b|困难}\n\n" +
                      "{a|" +
                      Math.round(params.data.percentage * 100) +
                      "%}"
                    );
                  },
                  position: "center",
                  show: true,
                  textStyle: {
                    fontSize: "18",
                    fontWeight: "normal",
                    color: "#06f",
                  },
                },
              },
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: "#FFAA00",
                    },
                    {
                      offset: 1,
                      color: "#FFD54D",
                    },
                  ]),
                  shadowColor: "#5FB878",
                  shadowBlur: 0,
                },
              },
            },
            // {
            //   // 间隔
            //   value: 2,
            //   name: "",
            //   itemStyle: {
            //     label: {
            //       show: false,
            //     },
            //     labelLine: {
            //       show: false,
            //     },
            //     color: "#fff",
            //     borderColor: "#fff",
            //     borderWidth: 0,
            //   },
            // },
            {
              value: 0, // tod
              name: "invisible",
              itemStyle: {
                normal: {
                  color: "#F0F2F5",
                },
                emphasis: {
                  color: "#F0F2F5",
                },
              },
            },
            // {
            //   // 间隔
            //   value: 2,
            //   name: "",
            //   itemStyle: {
            //     label: {
            //       show: false,
            //     },
            //     labelLine: {
            //       show: false,
            //     },
            //     color: "#fff",
            //     borderColor: "#fff",
            //     borderWidth: 0,
            //   },
            // },
          ],
        },
        {
          name: "第二个圆环",
          type: "pie",
          clockWise: true,
          radius: ["40%", "32%"],
          itemStyle: this.dataStyle,
          hoverAnimation: false,
          center: ["50%", "50%"],
          data: [
            {
              name: "中等",
              value: 0,
              percentage: 0, // 百分比
              label: {
                normal: {
                  rich: {
                    a: {
                      color: "rgba(0, 0, 0, 0.85)",
                      align: "center",
                      fontSize: 28,
                    },
                    b: {
                      color: "rgba(0, 0, 0, 0.45)",
                      align: "center",
                      fontSize: 14,
                    },
                  },
                  formatter: function (params) {
                    // console.log(params, "params2");
                    return (
                      "{b|中等}\n\n" +
                      "{a|" +
                      Math.round(params.data.percentage * 100) +
                      "%}"
                    );
                  },
                  position: "center",
                  show: true,
                  textStyle: {
                    fontSize: "14",
                    fontWeight: "normal",
                    color: "#fff",
                  },
                },
              },
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: "#31A8FF",
                    },
                    {
                      offset: 1,
                      color: "#5FD3FF",
                    },
                  ]),
                  shadowColor: "#01AAED",
                  shadowBlur: 0,
                },
              },
            },
            {
              value: 0,
              name: "invisible",
              itemStyle: {
                normal: {
                  color: "#F0F2F5",
                },
                emphasis: {
                  color: "#F0F2F5",
                },
              },
            },
          ],
        },
        {
          name: "第三个圆环",
          type: "pie",
          clockWise: true,
          radius: ["40%", "32%"],
          itemStyle: this.dataStyle,
          hoverAnimation: false,
          center: ["85%", "50%"],
          data: [
            {
              name: "简单",
              value: 0,
              percentage: 0, // 百分比
              label: {
                normal: {
                  rich: {
                    a: {
                      color: "rgba(0, 0, 0, 0.85)",
                      align: "center",
                      fontSize: 28,
                    },
                    b: {
                      color: "rgba(0, 0, 0, 0.45)",
                      align: "center",
                      fontSize: 14,
                    },
                  },
                  formatter: function (params) {
                    // console.log(params, "params3");
                    return (
                      "{b|简单}\n\n" +
                      "{a|" +
                      Math.round(params.data.percentage * 100) +
                      "%}"
                    );
                  },
                  position: "center",
                  show: true,
                  textStyle: {
                    fontSize: "14",
                    fontWeight: "normal",
                    color: "#fff",
                  },
                },
              },
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: "#2FC25B",
                    },
                    {
                      offset: 1,
                      color: "#43CF7C",
                    },
                  ]),
                  shadowColor: "#FF5722",
                  shadowBlur: 0,
                },
              },
            },
            {
              value: 0,
              name: "invisible",
              itemStyle: {
                normal: {
                  color: "#F0F2F5",
                },
                emphasis: {
                  color: "#F0F2F5",
                },
              },
            },
          ],
        },
      ],
    };
  },
  mounted() {
    // this.initQuery();
    window.addEventListener("resize", this.listenResizeFn);
  },
  methods: {
    initQuery() {
      if (this.courseList.length) {
        // 根据课程 查询
        // this.queryTestPaperNum(); // 试卷
        // this.findQuestionNum(); // 素材总数
        // this.findResourceNum(); // 素材总量
        // this.findResourceSize(); // 视频时长
        // this.findVideoTime(); // 题库数量
        this.findCourseSummary(); // 试卷、资源、素材、视频、题库
      } else {
        this.productList[2]["count"] = 0;
        this.typeList[0]["count"] = 0;
        this.typeList[1]["count"] = 0;
        this.typeList[2]["count"] = 0;
        this.typeList[3]["count"] = 0;
      }

      this.drawEchartsType();
      this.drawEchartsDrip();
      this.drawEchartsBottom1();
      this.drawEchartsBottom2();
      this.drawEchartsBottom3();
    },
    handleSelectChange(val, type, list) {
      // console.log(111111111111111, val, type, list);
      // console.log(type, this[type]);
      if (type === "organize") {
        this.queryOpenedProd(); // 已开通产品数
        this.queryCourseByStructId(); // 查询课程范围
      } else {
        this.initQuery();
      }
    },
    async drawEchartsType() {
      // let myChart = this.$echarts.init(document.getElementById("source_type"));
      this.myChart1 =
        this.myChart1 ||
        this.$echarts.init(document.getElementById("source_type"));
      // options = {}
      // 数据
      let datas = this.courseList.length
        ? await this.findResourceTypeCount()
        : [];
      // let datas = [
      //   { value: 1048, name: "PPT" },
      //   { value: 460, name: "动画" },
      //   { value: 580, name: "图形/图像" },
      //   { value: 300, name: "富文本" },
      //   { value: 1500, name: "文本" },
      //   { value: 200, name: "视频" },
      // ];
      this.option1.series[0].data = datas;
      this.option1.graphic.invisible = datas.length;

      this.myChart1.setOption(this.option1);
      // this.myChart1.resize();
    },
    async drawEchartsDrip() {
      // 水滴图
      // let myChart = this.$echarts.init(
      //   document.getElementById("source_percent")
      // );
      this.myChart2 =
        this.myChart2 ||
        this.$echarts.init(document.getElementById("source_percent"));
      // let option = {}
      /* data: [
        0.34, // tod
        // {
        //   value: 0.34,
        //   direction: "left",
        // },
      ] */

      // 数据
      let datas = this.courseList.length
        ? await this.findResourceActivityRatio()
        : [0];
      this.option2.series[0].data = datas;
      this.myChart2.setOption(this.option2);
      // this.myChart2.resize();
    },
    // bottom1
    async drawEchartsBottom1() {
      this.myChart3 =
        this.myChart3 ||
        this.$echarts.init(document.getElementById("bottom_type1"));

      let chartData = this.courseList.length
        ? await this.findQuestionRatio()
        : [
            {
              name: "主观题",
              value: 0,
              color: "#FCAFA9",
            },
            {
              name: "客观题",
              value: 0,
              color: "#30A9FF",
            },
          ];

      // let chartData = [
      //   {
      //     name: "主观题",
      //     value: 42111,
      //     unit: "个",
      //   },
      //   {
      //     name: "客观题",
      //     value: 81711,
      //     unit: "个",
      //   },
      // ];
      let arrName = [];
      let arrValue = [];
      let sum = 0;
      let pieSeries = [];

      // 数据处理
      chartData.forEach((v, i) => {
        arrName.push(v.name);
        arrValue.push(v.value);
        sum = sum + v.value;
      });

      // 图表option整理
      chartData.forEach((v, i) => {
        pieSeries.push({
          name: "题库",
          type: "pie",
          clockWise: true, //顺时加载
          hoverAnimation: false,
          radius: [50 - i * 15 + "%", 42 - i * 15 + "%"],
          center: ["50%", "50%"],
          label: {
            show: false,
          },
          data: [
            {
              value: v.value,
              name: v.name,
              displayValue: v.value,
              displayPercent: sum ? Number((v.value / sum).toFixed(4)) : 0,
              displayColor: v.color,
            },
            // 透明部分(无值时 设为全透明)
            {
              value: sum ? sum - v.value : 1,
              name: v.name,
              itemStyle: {
                color: "rgba(0,0,0,0)",
              },
              displayValue: v.value,
              displayPercent: sum ? Number((v.value / sum).toFixed(4)) : 0,
              displayColor: v.color,
            },
          ],
        });
        // 灰色背景
        pieSeries.push({
          name: "",
          type: "pie",
          silent: true,
          z: 1,
          clockWise: false, //顺时加载
          hoverAnimation: false, //鼠标移入变大
          radius: [50 - i * 15 + "%", 42 - i * 15 + "%"],
          center: ["50%", "50%"],
          label: {
            show: false,
          },
          data: [
            {
              value: 7.5,
              itemStyle: {
                color: "#F4EDF0",
              },
            },
          ],
        });
      });

      this.option3.series = pieSeries;
      this.myChart3.setOption(this.option3);
    },
    // bottom2
    async drawEchartsBottom2() {
      this.myChart4 =
        this.myChart4 ||
        this.$echarts.init(document.getElementById("bottom_type2"));
      // options = {}
      // 数据
      let datas = this.courseList.length
        ? await this.findQuestionTypeCount()
        : [];

      this.option4.series[0].data = datas;
      this.option4.graphic.invisible = datas.length;

      this.myChart4.setOption(this.option4);
    },
    // bottom3
    async drawEchartsBottom3() {
      // let myChart = this.$echarts.init(document.getElementById("bottom_type3"));
      this.myChart5 =
        this.myChart5 ||
        this.$echarts.init(document.getElementById("bottom_type3"));

      // 数据
      let datas = this.courseList.length
        ? await this.findQuestionDiffcultyCount()
        : [];
      let sum = 0; // 总题数
      let difficult = 0;
      let normal = 0;
      let simple = 0;
      let difficultMax = false; // 困难是否是最大值 处理和不为100%
      let normalMax = false;
      let simpleMax = false;
      let differenceValue = 0; // 差值（sum 和 1）
      datas.forEach((item) => {
        if (item.type == 3) {
          difficult = item.value;
        }
        if (item.type == 2) {
          normal = item.value;
        }
        if (item.type == 1) {
          simple = item.value;
        }
        sum += parseInt(item.value);
      });

      differenceValue = sum
        ? 1 -
          (Number((difficult / sum).toFixed(2)) +
            Number((normal / sum).toFixed(2)) +
            Number((simple / sum).toFixed(2)))
        : 0;
      difficultMax = difficult >= normal && difficult >= simple;
      normalMax = normal >= difficult && normal >= simple;
      simpleMax = simple >= difficult && simple >= normal;
      if (difficultMax && normalMax && simpleMax) {
        // 三者相等 给最后一个
        difficultMax = false;
        normalMax = false;
      } else if (difficultMax && normalMax) {
        // 两大者相等 给后者
        difficultMax = false;
      } else if (difficultMax && simpleMax) {
        // 两大者相等 给后者
        difficultMax = false;
      } else if (normalMax && simpleMax) {
        // 两大者相等 给后者
        normalMax = false;
      }

      this.option5.series[0].data[0].value = difficult; // 困难
      this.option5.series[0].data[0].percentage = sum
        ? difficultMax
          ? 1 -
            (Number((normal / sum).toFixed(2)) +
              Number((simple / sum).toFixed(2)))
          : Number((difficult / sum).toFixed(2))
        : 0;
      this.option5.series[0].data[1].value = sum ? sum - difficult : 1; // 困难

      this.option5.series[1].data[0].value = normal; // 一般
      this.option5.series[1].data[0].percentage = sum
        ? normalMax
          ? 1 -
            (Number((difficult / sum).toFixed(2)) +
              Number((simple / sum).toFixed(2)))
          : Number((normal / sum).toFixed(2))
        : 0;
      this.option5.series[1].data[1].value = sum ? sum - normal : 1; // 一般

      this.option5.series[2].data[0].value = simple; // 简单
      this.option5.series[2].data[0].percentage = sum
        ? simpleMax
          ? 1 -
            (Number((difficult / sum).toFixed(2)) +
              Number((normal / sum).toFixed(2)))
          : Number((simple / sum).toFixed(2))
        : 0;
      // this.option5.series[2].data[0].percentage =
      //   1 -
      //   (Number((difficult / sum).toFixed(2)) +
      //     Number((normal / sum).toFixed(2))); // 简单
      this.option5.series[2].data[1].value = sum ? sum - simple : 1; // 简单

      this.myChart5.setOption(this.option5);

      /* let option = {
        title: {
          show: true,
          text: "题库按难度分类",
          top: 20,
          left: 20,
          textStyle: {
            fontSize: 18,
            fontWeight: 400,
          },
        },
        backgroundColor: "#fff",
        series: [
          {
            name: "第一个圆环",
            type: "pie",
            clockWise: true,
            radius: ["40%", "32%"],
            itemStyle: dataStyle,
            hoverAnimation: false,
            center: ["15%", "50%"],
            data: [
              {
                value: 70, // tod
                label: {
                  normal: {
                    rich: {
                      a: {
                        color: "rgba(0, 0, 0, 0.85)",
                        align: "center",
                        fontSize: 28,
                      },
                      b: {
                        color: "rgba(0, 0, 0, 0.45)",
                        align: "center",
                        fontSize: 14,
                      },
                    },
                    formatter: function (params) {
                      return "{b|困难}\n\n" + "{a|" + params.value + "%}";
                    },
                    position: "center",
                    show: true,
                    textStyle: {
                      fontSize: "18",
                      fontWeight: "normal",
                      color: "#06f",
                    },
                  },
                },
                itemStyle: {
                  normal: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      1,
                      0,
                      0,
                      [
                        {
                          offset: 0,
                          color: "#FFAA00",
                        },
                        {
                          offset: 1,
                          color: "#FFD54D",
                        },
                      ]
                    ),
                    shadowColor: "#5FB878",
                    shadowBlur: 0,
                  },
                },
              },
              {
                // 间隔
                value: 2,
                name: "",
                itemStyle: {
                  label: {
                    show: false,
                  },
                  labelLine: {
                    show: false,
                  },
                  color: "#fff",
                  borderColor: "#fff",
                  borderWidth: 0,
                },
              },
              {
                value: 30, // tod
                name: "invisible",
                itemStyle: {
                  normal: {
                    color: "#F0F2F5",
                  },
                  emphasis: {
                    color: "#F0F2F5",
                  },
                },
              },
              {
                // 间隔
                value: 2,
                name: "",
                itemStyle: {
                  label: {
                    show: false,
                  },
                  labelLine: {
                    show: false,
                  },
                  color: "#fff",
                  borderColor: "#fff",
                  borderWidth: 0,
                },
              },
            ],
          },
          {
            name: "第二个圆环",
            type: "pie",
            clockWise: true,
            radius: ["40%", "32%"],
            itemStyle: dataStyle,
            hoverAnimation: false,
            center: ["50%", "50%"],
            data: [
              {
                value: 24,
                label: {
                  normal: {
                    rich: {
                      a: {
                        color: "rgba(0, 0, 0, 0.85)",
                        align: "center",
                        fontSize: 30,
                      },
                      b: {
                        color: "rgba(0, 0, 0, 0.45)",
                        align: "center",
                        fontSize: 16,
                      },
                    },
                    formatter: function (params) {
                      return "{b|一般}\n\n" + "{a|" + params.value + "%}";
                    },
                    position: "center",
                    show: true,
                    textStyle: {
                      fontSize: "14",
                      fontWeight: "normal",
                      color: "#fff",
                    },
                  },
                },
                itemStyle: {
                  normal: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      1,
                      0,
                      0,
                      [
                        {
                          offset: 0,
                          color: "#31A8FF",
                        },
                        {
                          offset: 1,
                          color: "#5FD3FF",
                        },
                      ]
                    ),
                    shadowColor: "#01AAED",
                    shadowBlur: 0,
                  },
                },
              },
              {
                value: 50,
                name: "invisible",
                itemStyle: {
                  normal: {
                    color: "#F0F2F5",
                  },
                  emphasis: {
                    color: "#F0F2F5",
                  },
                },
              },
            ],
          },
          {
            name: "第三个圆环",
            type: "pie",
            clockWise: true,
            radius: ["40%", "32%"],
            itemStyle: dataStyle,
            hoverAnimation: false,
            center: ["85%", "50%"],
            data: [
              {
                value: 11,
                label: {
                  normal: {
                    rich: {
                      a: {
                        color: "rgba(0, 0, 0, 0.85)",
                        align: "center",
                        fontSize: 30,
                      },
                      b: {
                        color: "rgba(0, 0, 0, 0.45)",
                        align: "center",
                        fontSize: 16,
                      },
                    },
                    formatter: function (params) {
                      return "{b|简单}\n\n" + "{a|" + params.value + "%}";
                    },
                    position: "center",
                    show: true,
                    textStyle: {
                      fontSize: "14",
                      fontWeight: "normal",
                      color: "#fff",
                    },
                  },
                },
                itemStyle: {
                  normal: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      1,
                      0,
                      0,
                      [
                        {
                          offset: 0,
                          color: "#2FC25B",
                        },
                        {
                          offset: 1,
                          color: "#43CF7C",
                        },
                      ]
                    ),
                    shadowColor: "#FF5722",
                    shadowBlur: 0,
                  },
                },
              },
              {
                value: 25,
                name: "invisible",
                itemStyle: {
                  normal: {
                    color: "#F0F2F5",
                  },
                  emphasis: {
                    color: "#F0F2F5",
                  },
                },
              },
            ],
          },
        ],
      }; */
      // myChart.setOption(option);
    },
    // ----------------------------
    // 获取组织
    queryStructFirstLevel() {
      api.queryStructFirstLevel(this.deptId).then((rs) => {
        if (rs.code == 0) {
          this.organizeList = rs.data;
        } else {
          this.$messageError(rs.msg);
        }
      });
    },
    // 课程范围
    queryCourseByStructId() {
      this.loading = true;
      let params = {
        userType: "0",
        structId: this.organize,
        courseName: "", // 模糊查询
      };
      api
        .queryCourseByStructId(params)
        .then((rs) => {
          if (rs.code == 0) {
            // if (rs.data.length) {
            //   this.course = rs.data[0].id; // 默认第一个课程
            // } else {
            //   this.course = "";
            // }
            this.course = "";
            this.courseList = rs.data;
            this.initQuery();
            this.productList[1]["count"] = rs.data.length;
            this.loading = false;
          } else {
            this.$messageError(rs.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getFamousQuotes() {
      api
        .getFamousQuotes()
        .then((rs) => {
          if (rs.status == 1) {
            this.updateTime = rs.createTime;
          } else {
            this.$messageError(rs.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 产品统计 已开通产品
    queryOpenedProd() {
      let params = {
        structId: this.organize, // 组织id
      };
      api
        .queryOpenedProd(params)
        .then((rs) => {
          if (rs.code == 0) {
            // this.productList
            this.productList[0]["count"] = rs.data.length;
          } else {
            this.$messageError(rs.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 即将到期
    queryWillExpiredProd() {
      api
        .queryWillExpiredProd()
        .then((rs) => {
          if (rs.code == 0) {
            this.loading = false;
            // this.productList
            // this.productList[0]['count'] = rs.data.length;
          } else {
            this.$messageError(rs.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 已到期
    queryExpiredPro() {
      api
        .queryExpiredPro()
        .then((rs) => {
          if (rs.code == 0) {
            this.loading = false;
            // this.productList
            // this.productList[0]['count'] = rs.data.length;
          } else {
            this.$messageError(rs.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 试卷资源
    queryTestPaperNum() {
      let params = {
        courseId: this.course,
      };
      return new Promise((resolve, reject) => {
        api
          .queryTestPaperNum(params)
          .then((rs) => {
            if (rs.code == 0) {
              this.productList[2]["count"] = rs.data;
              resolve(rs.data);
            } else {
              this.$messageError(rs.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    // 素材总数
    findResourceNum() {
      let params = {
        ids: [this.course], // 课程ID列表
      };
      return new Promise((resolve, reject) => {
        api
          .findResourceNum(params)
          .then((rs) => {
            if (rs.code == 0) {
              this.typeList[0]["count"] = rs.data;
              resolve(rs.data);
            } else {
              this.$messageError(rs.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    // 素材总量
    findResourceSize() {
      let params = {
        ids: [this.course], // 课程ID列表
      };
      return new Promise((resolve, reject) => {
        api
          .findResourceSize(params)
          .then((rs) => {
            if (rs.code == 0) {
              this.typeList[1]["count"] = rs.data.num || 0;
              this.typeList[1]["unit"] = rs.data.letter || "G";
              resolve(rs.data);
            } else {
              this.$messageError(rs.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    // 视频时长
    findVideoTime() {
      let params = {
        ids: [this.course], // 课程ID列表
      };
      return new Promise((resolve, reject) => {
        api
          .findVideoTime(params)
          .then((rs) => {
            if (rs.code == 0) {
              this.typeList[2]["count"] = rs.data;
              resolve(rs.data);
            } else {
              this.$messageError(rs.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    // 题库总量
    findQuestionNum() {
      let params = {
        ids: [this.course], // 课程ID列表
      };
      return new Promise((resolve, reject) => {
        api
          .findQuestionNum(params)
          .then((rs) => {
            if (rs.code == 0) {
              this.typeList[3]["count"] = rs.data;
              // this.productList[3]["count"] = rs.data;
              resolve(rs.data);
            } else {
              this.$messageError(rs.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    // 素材分类统计-图1
    findResourceTypeCount() {
      let params = {
        structId: this.organize,
        ids: this.course ? [this.course] : [], // 课程ID列表
      };
      return new Promise((resolve, reject) => {
        api
          .findResourceTypeCount(params)
          .then((rs) => {
            if (rs.code == 0) {
              if (rs.data && rs.data.length) {
                resolve(
                  rs.data.map((item) => {
                    return {
                      name: item.name,
                      value: item.num,
                    };
                  })
                );
              } else {
                resolve([]);
              }
              // resolve([
              //   { value: 1048, name: "PPT" },
              //   { value: 460, name: "动画" },
              //   { value: 580, name: "图形/图像" },
              //   { value: 300, name: "富文本" },
              //   { value: 1500, name: "文本" },
              //   { value: 200, name: "视频" },
              // ]);
            } else {
              resolve([]);
              this.$messageError(rs.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    // 活跃资源-图2
    findResourceActivityRatio() {
      // return Promise.resolve([0.34]);
      let params = {
        structId: this.organize,
        ids: this.course ? [this.course] : [], // 课程ID列表
        type: "0", // 0管理员 1老师
      };
      return new Promise((resolve, reject) => {
        api
          .findResourceActivityRatio(params)
          .then((rs) => {
            if (rs.code == 0) {
              resolve([rs.data / 100]);
            } else {
              resolve([0]);
              this.$messageError(rs.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    // 主客观题占比-图3
    findQuestionRatio() {
      let params = {
        structId: this.organize,
        ids: this.course ? [this.course] : [], // 课程ID列表
      };
      return new Promise((resolve, reject) => {
        api
          .findQuestionRatio(params)
          .then((rs) => {
            if (rs.code == 0) {
              // if (rs.data.length) {
              //   resolve(
              //     rs.data.map((item) => {
              //       return {
              //         name: item.name,
              //         value: item.num,
              //       };
              //     })
              //   );
              // }

              resolve([
                {
                  name: "主观题",
                  value: rs.data.subjective || 0,
                  color: "#FCAFA9",
                },
                {
                  name: "客观题",
                  value: rs.data.objective || 0,
                  color: "#30A9FF",
                },
              ]);
            } else {
              resolve([
                {
                  name: "主观题",
                  value: 0,
                  color: "#FCAFA9",
                },
                {
                  name: "客观题",
                  value: 0,
                  color: "#30A9FF",
                },
              ]);
              this.$messageError(rs.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    // 题型分类-图4
    findQuestionTypeCount() {
      let params = {
        structId: this.organize,
        ids: this.course ? [this.course] : [], // 课程ID列表
      };
      return new Promise((resolve, reject) => {
        api
          .findQuestionTypeCount(params)
          .then((rs) => {
            if (rs.code == 0) {
              if (rs.data && rs.data.length) {
                resolve(
                  rs.data.map((item) => {
                    return {
                      name: item.name,
                      value: item.num,
                    };
                  })
                );
              } else {
                resolve([]);
              }

              // resolve([
              //   { value: 1048, name: "单选题" },
              //   { value: 460, name: "多选题" },
              //   { value: 580, name: "判断题" },
              // ]);
            } else {
              resolve([]);
              this.$messageError(rs.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    // 试题难度分类-图5
    findQuestionDiffcultyCount() {
      let params = {
        structId: this.organize,
        ids: this.course ? [this.course] : [], // 课程ID列表
      };
      return new Promise((resolve, reject) => {
        api
          .findQuestionDiffcultyCount(params)
          .then((rs) => {
            if (rs.code == 0) {
              if (rs.data.length) {
                resolve(
                  rs.data
                    .filter((item) => item.questionType != 0)
                    .map((item) => {
                      return {
                        name: item.name,
                        value: item.num,
                        type: item.questionType,
                      };
                    })
                );
              } else {
                resolve([]);
              }

              // resolve([
              //   { value: 1048, name: "困难" },
              //   { value: 460, name: "一般" },
              //   { value: 580, name: "简单" },
              // ]);
            } else {
              resolve([]);
              this.$messageError(rs.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    // 试卷、资源、素材、视频、题库
    findCourseSummary() {
      let params = {
        structId: this.organize,
        ids: this.course ? [this.course] : [], // 课程ID列表
      };
      return new Promise((resolve, reject) => {
        api
          .findCourseSummary(params)
          .then((rs) => {
            if (rs.code == 0) {
              // this.typeList[3]["count"] = rs.data;
              // this.productList[3]["count"] = rs.data;
              this.typeList[0]["count"] = rs.data.resourceNum;
              this.typeList[1]["count"] = rs.data.sizeMap
                ? rs.data.sizeMap.num
                : 0;
              this.typeList[1]["unit"] = rs.data.sizeMap
                ? rs.data.sizeMap.letter
                : "G";
              this.typeList[2]["count"] = rs.data.videoTime;
              this.typeList[3]["count"] = rs.data.questionNum;
              this.productList[2]["count"] = rs.data.paperNum;
              resolve(rs.data);
            } else {
              this.$messageError(rs.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    listenResizeFn() {
      this.myChart1.resize();
      this.myChart2.resize();
      this.myChart3.resize();
      this.myChart4.resize();
      this.myChart5.resize();
    },
  },
  filters: {
    formatTime(time) {
      return new Date(time)._$formatDateZh();
    },
  },
  beforeDestroy() {
    // 移除绑定的listenResizeFn事件监听
    window.removeEventListener("resize", this.listenResizeFn);
  },
};
</script>
<style lang="scss" scoped>
.resource_statistic_wrap {
  --fontSize: calc(100vw / 19.2);
  box-sizing: border-box;
  padding-bottom: 8px;
  overflow-y: scroll;

  .resource_statistic_header {
    .header_group {
      font-size: 14px;
      .item {
        padding-right: 10px;
        .el-select {
          // width: 120px;
        }
        .el-date-editor--daterange.el-input__inner {
          width: 246px;
        }
        /deep/ .el-select-dropdown {
          width: 100% !important;
        }
      }
    }
  }

  .product_section {
    background: #fff;
    padding: 10px 20px 20px;
    margin-top: 18px;

    .product_section_header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .header_left {
        display: flex;
        align-items: center;

        .product_title {
          padding: 12px 0 10px 12px;
          margin-right: 10px;
          font-size: 18px;
          // border-right: 1px solid #ccc;
        }

        .el-button--text {
          font-weight: 600;
        }
      }

      .header_right {
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 14px;
        color: rgba(166, 166, 166, 1);
      }
    }
    .product_section_list {
      display: flex;
      justify-content: space-between;

      .product_tiem {
        display: flex;
        flex: 1;
        border-radius: 16px;
        background: rgba(239, 249, 255, 0.48); // tod  0.48
        border: 1px solid rgba(233, 247, 255, 1);
        padding: 18px;
        margin-right: 30px;

        .product_left {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 56px;
          height: 56px;
          background: rgba(87, 193, 255, 0.1);
          border-radius: 20px;

          .iconMin {
            width: 50%;
            height: 50%;
            background-size: 100% 100%;
          }
        }
        .product_right {
          display: flex;
          flex-flow: column;
          justify-content: center;
          padding-left: 12px;
          font-size: 14px;
          color: rgba(166, 166, 166, 1);

          .product_count {
            padding-bottom: 5px;
            font-size: 22px;
            color: #000;
          }
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .type_section {
    display: flex;
    margin-top: 28px;

    .type_section_list {
      width: 40%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .type_tiem {
        display: flex;
        min-width: 40%;
        flex: 1;
        border-radius: 16px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(255, 255, 255, 1);
        box-shadow: -4px -4px 10px 0px rgba(255, 255, 255, 0.8),
          4px 4px 10px 0px rgba(222, 221, 227, 1);
        padding: 18px;
        justify-content: space-around;
        margin: 0 10px 10px 0;

        .type_right {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 93px;
          height: 93px;
          opacity: 1;
          border-radius: 30px;
          background: linear-gradient(
            180deg,
            rgba(243, 245, 247, 1) 0%,
            rgba(243, 245, 247, 1) 9.91%,
            rgba(254, 254, 255, 1) 100%
          );
          border: 1px solid rgba(255, 255, 255, 1);
          box-shadow: -4px -4px 10px 0px rgba(255, 255, 255, 0.8),
            4px 4px 10px 0px rgba(222, 221, 227, 1);

          .iconMin {
            width: 50%;
            height: 50%;
            background-size: 100% 100%;
          }
        }
        .type_left {
          display: flex;
          flex-flow: column;
          justify-content: center;
          padding-left: 12px;
          font-size: 14px;
          color: #000;

          .type_count {
            padding-bottom: 5px;
            font-size: 22px;
            font-weight: 700;

            .unit {
              font-size: 12px;
            }
          }
        }
      }
    }

    .echarts_item {
      flex: auto;
      border-radius: 4px;
      background: #fff;
      margin-right: 20px;

      // &.item1 {
      //   flex: auto
      // }
      // &.item2 {
      //   flex: auto
      // }
    }
  }

  .aphorism {
    height: calc(0.73 * var(--fontSize));
    margin-top: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/resourceStatistic/resourceStatisticAdmin.vue